export { initObservers } from './observers';
export { initInputObserver } from './inputObserver';
export { initMutationObserver } from './mutationObserver';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@datadog/browser-rum/esm/domain/record/observers/index.js
// module id = 449
// module chunks = 0